var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.toBeDisplayed.trim().length > 0)?_c('span',{staticClass:"contract",domProps:{"innerHTML":_vm._s(_vm.toBeDisplayed.trim().length > 0 ? _vm.toBeDisplayed : '\xa0')}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }